export default __webpack_public_path__ + "static/media/IMG_0060_6_11zon.747ac1d4.jpg";